'use client';
import {
  GoogleCalendarIcon,
  BackArrow,
  GoogleCalendarIconSetting,
  OutLookIcon,
  ICloudIconList,
} from '@mybridge/icons';
import {
  Flex,
  Heading,
  useDisclosure,
  Spinner,
  Box,
  HStack,
} from '@mybridge/ui';
import { Button } from '@mybridge/ui/button';
import { Input } from '@mybridge/ui/input';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@mybridge/ui/modal';
import { Text } from '@mybridge/ui/text';
import { useMutation, useQuery } from '@tanstack/react-query';
import {
  getGoogleIntegrationUrl,
  getOutlookIntegrationUrl,
  getGoogleIntegrationCallback,
  getConnectedCalendarList,
  getConnectedMeetingList,
} from 'packages/mybridgev4/store/slices/settingsSlice.js';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCalendarIntegrationURL,
  getIntegrationURL,
} from 'v4/lib/api/google-integration';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import { useRouter } from 'next/router';
import { useToast } from '@mybridge/ui';
import { isMobile } from 'react-device-detect';
import GoogleMeetIntegration from './GoogleMeetIntegration';
import ZoomConfrencingCard from './ZoomConfrencingCard';
import { ExchangeIcon } from '@mybridge/icons/ExchangeIcon';
// import VideoConfrencingIntegration from './ConfrencingList';
import { GoogleMeetIcon } from '@mybridge/icons/GoogleMeetIcon';
// import { ZoomIcon } from '@mybridge/icons/ZoomIcon';
import { MicroSoftTeamsIcon } from '@mybridge/icons/MicroSoftTeamsIcon';
import { GotoIcon } from '@mybridge/icons/GotoIcon';
import { WebexTeamsIcon } from '@mybridge/icons/WebexTeamsIcon';
import { ZoomIcon } from '@mybridge/icons/ZoomIcon';
// import GoogleMeetIntegration from './GoogleMeetIntegration';
import VideoConferencingIntegration from './ConfrencingList';
import MicrosoftMeetingIntegration from './MicrosoftMeetingIntegration';
import WebexIntegration from './WebexIntegration';
import GotoMeetIntegration from './GotoMeetIntegration';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export default function VideoConfrencing({ setSelectedComponent }) {
  const dispatch = useDispatch();
  const { t } = useTranslator();
  const router = useRouter();
  const toast = useToast();
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const [modalOpen, setModalOpen] = useState(false);
  const [heading, setHeading] = useState(null);
  const [googleLinked, setGoogleLinked] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { loggedIn } = useSelector((state) => state.user);

  const [isOpenDetailedView, setIsopenDetailedView] = useState('');

  const [calendars, setCalendars] = useState([
    {
      icon: <GoogleMeetIcon width="60" height="60" />,
      title: 'Google meet',
      translationKey: 'myCalendar.googleMeet',
      key: 'google',
      description: t('settingsIntegration.includeGoogleMeet') || 'Include Google Meet details in your myBridge events.',
      descriptionKey: 'settingsIntegration.includeGoogleMeet',
      isConnected: false,
      id: 0,
    },
    {
      icon: <ZoomIcon width="60" height="60" />,
      title: "zoom",
      key: "zoom",
      description: t('settingsIntegration.includeZoom') || 'Include Zoom details in your myBridge events.',
      isConnected: false,
      id: 1,
    },
    {
      icon: <MicroSoftTeamsIcon width="64.4" height="60" />,
      title: 'Microsoft teams conferencing',
      translationKey: 'settingsIntegration.microsoftTeams',
      key: 'ms_teams',
      description:
        t('settingsIntegration.includeTeams') || 'Include Teams conferencing details in your myBridge events.',
      isConnected: false,
      id: 2,
    },
    {
      icon: <GotoIcon width="101.85" height="52" />,
      title: 'GoTo Meeting Information',
      translationKey: 'settingsIntegration.goToMeeting',
      key: 'gotomymeeting',
      description: t('settingsIntegration.includeGoToMeeting') || 'Include GoTo meeting details in your myBridge events.',
      isConnected: false,
    },
    {
      icon: <WebexTeamsIcon width="72.22" height="52" />,
      title: 'Webex Information',
      translationKey: 'settingsIntegration.webex',
      key: "webex",
      description: t('settingsIntegration.includeWebex') || 'Include Webex details in your myBridge events.',
      isConnected: false,
      id: 3,
    },
  ]);

  useEffect(()=>{
    if(typeof window === 'undefined') return;
    const { title } = router.query;
    switch (title) {
      case 'google_meet':
        setIsopenDetailedView('Google meet')
        break;
      case 'ms_teams':
        setIsopenDetailedView('Microsoft teams conferencing')
        break;
      case 'webex':
        setIsopenDetailedView('Webex Information')
        break;
      case 'gotomymeeting':
        setIsopenDetailedView('GoTo Meeting Information')
        break;
      case 'zoom':
        setIsopenDetailedView('zoom')
        break;
      default:
        break;
    }      
  }, [router?.query])

  useEffect(() => {
    if (typeof window === 'undefined') return;
    window.addEventListener(
      'message',
      (event) => {
        if (event.data?.msg == 'showIntegrationModal') {
          setModalOpen(true);
        }
      },
      []
    );
  });

  const { googleIntLink } = useQuery(
    ['getCalIntLink'],
    getCalendarIntegrationURL,
    {
      refetchOnWindowFocus: false,
      onError(err) {
        console.log(err);
      },
      onSuccess(data) {
        if (data.error === 'already_integrated') {
          setGoogleLinked(true);
        }
      },
    }
  );
  const { mutate, isLoading, error } = useMutation(getCalendarIntegrationURL, {
    onSuccess: (data) => {

      setHeading('google');
      if (data?.error) {
        alert(data.error);
      } else {
        const { url = null } = data;
        // const url =
        //   'https://accounts.google.com/o/oauth2/v2/auth?client_id=350980133077-q3kqbcvc6umqeb09lqv9jg2b9vod68f5.apps.googleusercontent.com&redirect_uri=http%3A%2F%2Flocalhost:4200%2Fsettings%2Fintegration&response_type=code&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fcalendar&access_type=offline&state=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzA2Nzc2NDEwLCJpYXQiOjE3MDY2OTAwMTAsImp0aSI6IjA1NmMwMzMxZWRiNTQxZTVhYWQ0YzY4NDQ2YTU2Mzc5IiwidXNlcl9pZCI6NzcwfQ.A5L1TVdWzPCPH2nayq6L-B4jowmHccXFZ2tWQwxNzlE&include_granted_scopes=true';
        // console.log(url);
        if (url) {
          // window.open(url, 'mywin', 'width=500,height=500');
          router.push(url);
        }
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });
  //   const navigate = useNavigate();
  const integrateCalender = (platform) => {
    switch (platform) {
      case 'google':
        dispatch(getGoogleIntegrationUrl())
          .then((res) => {
            window.open(res.payload.url, '_blank', 'width=500,height=500');
            // navigate(googleIntegrationUrl);
          })
          .catch((err) => console.log('Integrating google failed', err));
        break;
      case 'outlook':
        dispatch(getOutlookIntegrationUrl())
          .then((res) => {
            window.open(res.payload.url, '_blank', 'width=500,height=500');
            // navigate(outlookIntegrationUrl);
          })
          .catch((err) => console.log('Integrating google failed', err));
        break;
      default:
        break;
    }
  };

  const { mutate: contactMutate, loading } = useMutation(getIntegrationURL, {
    onSuccess: (data) => {
      const { url = null } = data?.data;
      // const url = 'https://accounts.google.com/o/oauth2/v2/auth?client_id=350980133077-q3kqbcvc6umqeb09lqv9jg2b9vod68f5.apps.googleusercontent.com&redirect_uri=http%3A%2F%2Flocalhost:4200%2Fsettings%2Fintegration&response_type=code&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fcontacts.readonly&access_type=offline&state=public__770&include_granted_scopes=true';
      // setHeading('contacts');
      if (url) {
        window.open(url, 'mywin', 'width=500,height=500');
        // window.open(url);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const handleClick = (e) => {
    contactMutate();
  };

  useEffect(() => {
    if (router?.query?.code) {
      const payload = {
        state: router?.query?.state,
        scope: router?.query?.scope,
        code: router?.query?.code,
        prompt: router?.query?.prompt,
        authuser: router?.query?.authuser,
        hd: router?.query?.hd,
      };
      dispatch(getGoogleIntegrationCallback(payload)).then((res) => {
        if (res?.payload?.status_code === 200) {
          toast({
            title: 'Success',
            description: res?.payload?.data,
            status: 'success',
            duration: 9000,
            isClosable: true,
          });
          router.push('/settings/integration?status=success');
        } else {
          // toast({
          //   title: 'Error',
          //   description:
          //     'Microsoft does not support online meetings for personal accounts. To use this integration, please create a Microsoft Teams account or an Office 365 Education account.',
          //   status: 'error',
          //   duration: 10000,
          //   isClosable: true,
          //   position: 'top',
          // });
          router.push('/settings/integration?status=failed');
        }
      });
    }
  }, [router]);

  // console.log(router);
  useEffect(() => {
    if(loggedIn){
    dispatch(getConnectedMeetingList()).then((res) => {
        setCalendars((prevCalendars) =>
          prevCalendars.map((calendar) => {
            // Find the connected calendar from the response
            const connectedCalendar = res?.payload?.find(
              (connected) => connected.provider.toLowerCase() === calendar.key
            );
            // If connected calendar is found, update isConnected and id
            if (connectedCalendar) {
              return {
                ...calendar,
                isConnected: true,
                id: connectedCalendar.id, // Update id from connected calendar
              };
            }
  
            // If no match, set isConnected to false
            return { ...calendar, isConnected: false };
          })
        );
      });
    }
  }, [dispatch]); // Add `dispatch` as a dependency

  return (
    <AuthenticatedProviders>
      <Box w="100%" className="user-settings--integration">
        <Box>
       {!isMobile && <Heading
            as="h4"
            size="md"
            p={['10px', '0 0 10px']}
          >
            <HStack>
              {' '}
              {isMobile && (
                <BackArrow onClick={() => setSelectedComponent()} />
              )}{' '}
              {/* <Text color="#3D5A80" fontWeight={'normal'}>
                {isOpenDetailedView ? isOpenDetailedView : t('settingsIntegration.videoConferencing') || 'Video Confrencing'}
              </Text> */}
              <Text color="#3D5A80" fontWeight={'normal'}>
                {isOpenDetailedView 
                  ? (calendars.find(cal => cal.title === isOpenDetailedView)?.translationKey 
                    ? t(calendars.find(cal => cal.title === isOpenDetailedView).translationKey) 
                    : isOpenDetailedView)
                  : t('settingsIntegration.videoConferencing') || 'Video Conferencing'}
              </Text>
            </HStack>
          </Heading>}
          {/* <GoogleMeetIntegration /> */}

          {isOpenDetailedView !== ('Google meet') && isOpenDetailedView !== ('zoom') && isOpenDetailedView !== ('Microsoft teams conferencing') &&
              isOpenDetailedView !== ('Webex Information') && isOpenDetailedView !== ('GoTo Meeting Information') &&
            (
              <VideoConferencingIntegration
              setSelectedComponent={setSelectedComponent}
                calendars={calendars}
                setIsopenDetailedView={setIsopenDetailedView}
                isMobile={isMobile}
                t={t}
              />
            )}

          {isOpenDetailedView === 'Google meet' && <GoogleMeetIntegration setCalendars={setCalendars} calendars={calendars} />}
          {isOpenDetailedView === 'zoom' && <ZoomConfrencingCard setCalendars={setCalendars} calendars={calendars} />}
          {isOpenDetailedView === 'Microsoft teams conferencing' && <MicrosoftMeetingIntegration setCalendars={setCalendars} calendars={calendars} />}
          {isOpenDetailedView === 'Webex Information' && <WebexIntegration setCalendars={setCalendars} calendars={calendars} />}
          {isOpenDetailedView === 'GoTo Meeting Information' && <GotoMeetIntegration setCalendars={setCalendars} calendars={calendars} />}

          {/* <Box>
            <Box
              p={['0 10px', 0]}
              {...(googleLinked
                ? {
                    'aria-label': 'Already linked!',
                    'data-microtip-position': 'top',
                    role: 'tooltip',
                  }
                : {})}
            >
              <Button
                variant={
                  userProfileInfo?.google_calendar_email === null
                    ? 'primary'
                    : 'secondary'
                }
                // isDisabled={!googleIntLink}
                onClick={() => {
                  if (userProfileInfo?.google_calendar_email) {
                    setHeading('google');
                    setModalOpen((prevState) => !prevState);
                  } else {
                    mutate();
                  }
                }}
              >
                {isLoading ? (
                  <Spinner />
                ) : (
                  <>
                    <GoogleCalendarIcon
                      width="18px"
                      color={
                        userProfileInfo?.google_calendar_email === null
                          ? 'white'
                          : 'green'
                      }
                    />
                    <Text
                      ms="10px"
                      color={
                        userProfileInfo?.google_calendar_email === null
                          ? 'white'
                          : 'grey'
                      }
                    >
                      {userProfileInfo?.google_calendar_email
                        ? `Integrated with ${userProfileInfo?.google_calendar_email}`
                        : 'Google Calendar'}
                    </Text>
                  </>
                )}
              </Button>
            </Box>
          </Box> */}
        </Box>

        {/* <Box>
          <Box p={['0 10px', 0]}>
            <Heading as="h4" size="md" mt="30px" mb="10px">
              Personal Contacts
            </Heading>
            <Text>See who you already know</Text>
            <Text my="10px">
              Syncing your contacts is the fastest way to grow your network.
              We&apos;ll periodically import and store your contacts to help you
              and others connect. You choose who to connect to and who to
              invite.
            </Text>
          </Box>
          <Flex gap="4" mb={[5, 0]} p={['0 10px', 0]}>
            <Input type="text" placeholder="Email" />
            <Button size="lg" onClick={() => handleClick()} variant="primary">
              Continue
            </Button>
          </Flex>
        </Box> */}

        {/* <Modal
          isOpen={modalOpen && heading === 'google'}
          onClose={() => setModalOpen(false)}
          isCentered
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Calendar Integration</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              You have synced your Google and myBridge calendars
            </ModalBody>

            <ModalFooter>
              <Button variant="primary" onClick={() => setModalOpen(false)}>
                OK
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal> */}

        {/* <Modal
          isOpen={modalOpen && heading === 'contacts'}
          onClose={() => setModalOpen(false)}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Syncing your contact</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              You're good to go, your contacts have been have synced
            </ModalBody>

            <ModalFooter>
              <Button variant="primary" onClick={() => setModalOpen(false)}>
                OK
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal> */}
      </Box>
    </AuthenticatedProviders>
  );
}
